import ApiServiceV2 from '@/helpers/api.service.v2';
import axios from 'axios';

const APIV2 = new ApiServiceV2();

export const state = {
   
}

export const mutations = {
    
}

export const actions = {
    actionSMSBlastAPIPOST(_, {params, action, hidePreloader = false}) {
        return new Promise((resolve, reject) => {
            if (hidePreloader) {
                // Use axios directly with hidePreloader config
                const API_URL = process.env.VUE_APP_APIURL + '/v6/others';
                axios.post(`${API_URL}/smsblast/campaign/${action}`, params, { hidePreloader: true })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
            } else {
                // Use normal API service (with preloader)
                APIV2.post(`/smsblast/campaign/${action}`, params)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
            }
        });
    },
}

export const getters = {
    
}